import React from 'react'
import Layout from '../components/Layout'
import Banner from '../components/Banner'
import SEO from '../components/Seo' 

export default function Page() {

    return (
        <>
            <SEO
                title="Instant Checkmate Login - How to log in to your Account"
                description="Logging in to your Instant Checkmate Account is easy. Watch our How-To Video or follow along with the instructions here."
            />
            <Layout>
                <div className="mainContainer">
                    <div className="container-fluid s2">
                        <div className="container">
                            <div className="row">
                                <h1 className="center">How To Create An Instant Checkmate Account</h1>
                                <div className="container center">
                                    <p className="h2"><b>INSTRUCTIONS:</b> CREATING AN ACCOUNT</p>
                                    <hr />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <h2>How-To Guide: Create Your Account</h2>
                                    <ol>
                                        <li>Go to <a href="https://www.instantcheckmate.com">www.InstantCheckmate.com</a> and search for someone you want to learn more about.</li>
                                        <li>To get the most accurate results, enter their complete first and last name and the state they live in. You can also search for yourself.</li>
                                        <li>We'll compile your first report and create your Instant Checkmate account.</li>
                                        <li>Choose your own username and password when prompted. This allows you to <a href="https://www.instantcheckmate.com/dashboard/login/">sign in to your account</a> anytime.</li>
                                    </ol>
                                    <h3>What Do You Get With An Account?</h3>
                                    <p>An Instant Checkmate membership may tell you who has a criminal record and who doesn’t. It may also reveal someone’s address, known aliases, traffic tickets, and other information. We collect millions of records from federal, state, and local sources.</p>
                                    <h3>How Do I Contact Member Support?</h3>
                                    <p>If you ever have a question about your service or your account, we’re always ready to help. Our member care team is available 24 hours a day, 7 days a week (some holiday hours may vary) to help you with whatever you need. You can call 1-800-222-8985 or email <a href="mailto:support@instantcheckmate.com">support@instantcheckmate.com</a>.</p>
                                </div>
                                <div className="col-md-6">
                                    <h3>Instant Checkmate Memberships</h3>
                                    <p>An Instant Checkmate membership may tell you who has a criminal record and who doesn’t. It may also reveal someone’s address, known aliases, traffic tickets, and other information. We collect millions of records from federal, state, and local sources.</p>
                                    <p>Then we compile those records into easy-to-read background reports. When you have all of this information at your fingertips, you can uncover the truth about your friends, family, and almost anyone else you want to learn more about.</p>
                                    <h3>What Are The Terms Of Use?</h3>
                                    <p>To see the complete terms of use, <a href="https://www.instantcheckmate.com/terms-of-use/">click here</a>.</p>
                                    <h3>How Do You Cancel An Instant Checkmate Account?</h3>
                                    <p>Ready to end your membership? We make it easy to cancel your account. You can <a href="https://www.instantcheckmate.com/cancel/">visit this page</a> and enter your account information. You can also call the member care team, or you can <a href="mailto:support@instantcheckmate.com">email us with your account information</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container s1">
                        <div className="row">
                            <div className="container center">
                                <div className="embed-responsive embed-responsive-16by9">
                                    <iframe title="unique" className="embed-responsive-item" src="https://www.youtube.com/embed/3N4KiLQ-AAI?rel=0&amp;showinfo=0"></iframe>
                                </div>
                            </div>
                            <p>Watch this video to learn how to create an Instant Checkmate account!</p>
                            <p className="center"><span className="label label-success">Difficulty: Easy</span>
                                <span className="label label-info">Estimated Time: 5-8 minutess</span></p>
                        </div>
                    </div>

                </div>
                <Banner />
            </Layout>
        </>
    )
}